/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 相近词匹配组件（使用新的 Redux Slice）
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-11-24 17:01:48
 */

import React from 'react'
import { Checkbox } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectExpandInfo,
  fetchPhotosV2
} from '../../../slices/photosByContentSlice'
import {
  selectSearchFilter,
  setSearchFilter
} from '../../../slices/photoFilterSlice'
import { buildFetchPhotosParamsWithOptions } from '../lib/photo'
import type { RootState } from '../../../app/store'

interface FuzzyMatchProps {
  onSensorOfClickEvent: (clickItem: string, restProperties: any) => void
}

const FuzzyMatchItem = ({ word }: { word: string }) => {
  const queryFilter = useSelector(selectSearchFilter)
  const correctKeyword = queryFilter?.searchKeywords?.[0] || ''

  // 比较correctKeyword和word,相同的文字返回黑色，不同的文字返回红色
  const renderChar = (char: string, index: number) => {
    if (correctKeyword[index] === char) {
      return <span key={index}>{char}</span>
    }
    return (
      <span key={index} style={{ color: '#ea4d3d' }}>
        {char}
      </span>
    )
  }

  if (!correctKeyword) return null

  return (
    <>
      {word.split('').map((char, index) => {
        return renderChar(char, index)
      })}
    </>
  )
}

const FuzzyMatch: React.FC<FuzzyMatchProps> = ({ onSensorOfClickEvent }) => {
  const dispatch = useDispatch()
  const groupId = useSelector((state: RootState) => state.group.groupId)
  const queryFilter = useSelector(selectSearchFilter)
  const expandInfo = useSelector(selectExpandInfo)

  const expandSynonym = expandInfo?.expandSynonym

  if (!expandSynonym || expandSynonym.total === 0) {
    return null
  }

  const handleVisibleChange = async (visible: boolean) => {
    if (!queryFilter || !groupId) return

    const newFilter = {
      ...queryFilter,
      useSynonym: visible
    }

    dispatch(setSearchFilter(newFilter))

    try {
      const params = buildFetchPhotosParamsWithOptions({
        queryFilter: newFilter,
        groupID: groupId,
        isAscSort: false
      })

      await (dispatch(fetchPhotosV2(params)) as any).unwrap()
      onSensorOfClickEvent('clickErrorCorrection', {
        isOpenErrorCorrection: visible
      })
    } catch (error) {
      console.error('切换相近词显示失败:', error)
    }
  }

  return (
    <div className="fuzzy-match-bar">
      <Checkbox
        checked={queryFilter?.useSynonym ?? true}
        onChange={(e) => handleVisibleChange(e.target.checked)}
      />
      <span style={{ marginLeft: 10 }}>
        同时显示 <strong>{expandSynonym.total}</strong> 张含{'"'}
        <strong>
          {expandSynonym.words.map((word, index) => {
            return (
              <React.Fragment key={index}>
                <FuzzyMatchItem word={word} />
                {index === expandSynonym.words.length - 1 ? '' : ', '}
              </React.Fragment>
            )
          })}
        </strong>
        {'"'}的照片
      </span>
    </div>
  )
}

export default FuzzyMatch
